<template>
  <div class="navbar ind-4" :class="navActive" v-on:mouseenter="setNavActive" v-on:mouseleave="removeNavActive">
    <div class="navbar-inner">
      <nav-button type="back" v-bind:clickevent="back_click" :customclass="[back.custom, navActive]">{{back.text}}</nav-button>

      <!-- content-inactive -->
      <a class="content-translate pdf-link" :class="[hasPDF, navActive]" :href="pdf" target="blank">
        <download-svg></download-svg> <span class="hide-sm">Download</span> PDF
      </a>

      <nav-button type="next" v-bind:clickevent="next_click" :customclass="[next.custom, navActive]">{{next.text}}</nav-button>
      
    </div>
  </div>
</template>

<script>
  import button from '../molecules/button'
  import vanilla_smooth_scroll from '../../utils/vanilla_smooth_scroll'
  import download_svg from '../svg/download'

  import {apiUrls} from '../../utils/api_addresses'
  import "babel-polyfill" // axios IE polyfill
  import axios from 'axios'
  axios.defaults.withCredentials = true;

  export default {
    props: ['nextCondition'],
    data () {
      return {
        w: null,
        pdf: null
      }
    },
    methods: {
      setPDF () {
        this.pdf = this.$store.state.pages[this.page].content.pdf
      },
      setNavActive () {
        this.$store.commit('setNavActive', 'nav-active')
      },
      removeNavActive () {
        this.$store.commit('setNavActive', '')
      },
      changePage (int) {
        const cb = (i) => {
          this.$store.commit('change_page', i)
          // axios update user page, but only if forward.
          if (i > 0) {
            axios.post(apiUrls.server.update, {
              current_page: (this.$store.state.page)
            })
            .catch((err) => {
              console.log(err)
            })
          }
        }
        if(this.w.pageYOffset > 0) {
          vanilla_smooth_scroll(0, 250)
          setTimeout(() => {
            cb(int)
          }, 250)
        } else {
          cb(int)
        }
      },
      uncheckAllCheckboxes () {
        let checkboxes = document.querySelectorAll('[radio]')
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false
        })
      },
      next_click () {
        
        // if nextCondition is falsey or a function that returns falsey do not change page.

        if(!this.nextCondition) return

        if (typeof this.nextCondition === 'function') {
          if (!this.nextCondition()) return
          this.$store.commit('setNextCondition', true) // reset nextCondition if truthy
        }

        // run behavior if nextCondition returns truthy

        // if checkbox exists, run checkbox page logic
        if (this.$store.state.checkbox.el && !this.$store.state.notification_state.active) {
          
          this.$store.commit('set_notification', {active: true})

        } else if (this.$store.state.checkbox.el && this.$store.state.notification_state.active) {
          
          let correct = this.$store.state.checkbox.correct

          if(correct === 'correct') {
            // reset checkbox and go to next page
            this.$store.commit('set_checkbox', {
              el: null
            })
            this.changePage(1)
          }

          this.$store.commit('set_notification', {active: false})

        } else {
          // if no checkbox found, go to next page
          this.changePage(1)
        }

      },
      back_click () {
        // todo: extract this
        this.$store.commit('setNextCondition', true) // reset nextCondition on back
        this.$store.commit('set_notification', {active: false})
        this.$store.commit('set_checkbox', {
          el: null
        })
        this.uncheckAllCheckboxes()
        this.changePage(-1)
      },
      // add first and last custom classes and computed methods
      set_first_last () {
        let page = this.$store.state.page
        let finish_page = this.$store.state.pages.length - 2
        let last_page = this.$store.state.pages.length -1
        // first page and survey page
        if (page < 2) { // first page is now survey
          this.$store.commit('set_navigation_next', {
            text: page < 1 ? 'submit' : 'begin',
            custom: 'call-to-action'
          })
          // disabe navigating back to pre-survey slide
          this.$store.commit('set_navigation_back', {
            custom: page < 1 ? 'button-disabled-invisible' : ''
          })
        }
        // last page
        else if (page === finish_page) {
          this.$store.commit('set_navigation_back', {
            custom: ''
          })
          this.$store.commit('set_navigation_next', {
            text: 'finish',
            custom: 'call-to-action'
          })
        }
        else if (page === last_page) {
          this.$store.commit('set_navigation_back', {
            custom: ''
          })
          this.$store.commit('set_navigation_next', {
            text: '',
            custom: 'button-disabled-invisible'
          })
        }
        // anything else
        else {
          this.$store.commit('set_navigation_back', {
            custom: ''
          })
          this.$store.commit('set_navigation_next', {
            text: 'next',
            // custom: ''
          })
        }
      }
    },
    computed: {
      page () {
        return this.$store.state.page
      },
      back () {
        return this.$store.state.navigation.back
      },
      next () {
        return this.$store.state.navigation.next
      },
      hasPDF () {
        if (this.pdf) {
          return ''
        } else {
          return 'content-inactive'
        }
      },
      navActive () {
        return this.$store.state.navActive
      }
    },
    components: {
      'nav-button': button,
      'download-svg': download_svg
    },
    mounted () {
      this.set_first_last()
      this.w = window
    },
    watch: {
      page () {
        this.setPDF()
        this.set_first_last()
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '../../styles/variables';

  .navbar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 96px;
    transition: all $transition-1;
    cursor: pointer;
    // background: rgba(81, 153, 211, 0.8);
    &.nav-active {
      background: $nav-blue;
    }
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      background: $nav-blue; //$white-solid;
      box-shadow: 0 -2px 5px 0 rgba(0,0,0,0.05);
    }
    @media screen and (max-width: $sm-max) {
      height: 60px;
    }
  }

  .navbar-inner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 80px - 80px);
    height: 100%;
    @media screen and (max-width: $sm-break) {
      width: calc(100% - 24px - 24px);
    }
  }

  .pdf-link {
    color: $black !important;
    text-decoration: none;
    margin-top: 12px;
    &:hover {
      text-decoration: underline;
    }
    &.nav-active {
      color: $white !important;
    }
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      color: $white !important;
    }
    @media screen and (max-width: $sm-max) {
      margin-top: 0px;
    }
  }

</style>

<style lang="scss">
  @import '../../styles/variables';
  .pdf-link {
    &.nav-active {
      svg {
        .pdf-fill-group {
          fill: $white;
        }
      }
    }
  }

  .pdf-fill-group {
    transition: all $transition-1;
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      fill: $white;
    }
  }

</style>


// WEBPACK FOOTER //
// navbar.vue?47eda330